import {passwordStrenthFuc,validatePassword} from '@/utils/common.js'

const passwordMixin = {
    data() {
        let _this = this;
        return {
            passwordRules: {
                telPhone:{ required: true, message: this.$t('不能为空'), trigger: 'blur'},
                code:{ required: true, message: this.$t('不能为空'), trigger: 'blur' },
                password: [{ required: true, trigger: 'blur', validator: validatePassword }],
                password2: [{ required: true, trigger: 'blur', validator: _this.validatePassword3 }]
            },
            forgettime:0,
            passwordForm: {
                telPhone:'',
                code:'',
                areaCode:'',
                password: '',
                password2: ''
            }
        }
    },
    methods: {
        validatePassword3(rule, value, callback){
            if(this.passwordForm.password !=value){
                callback(new Error(this.$t('密码不一致')))
            }else{
                callback()
            }
        },
        getMessageCodeForget(){
            let telPhone = this.passwordForm.telPhone;
            if(!telPhone){
                this.$message({message:this.$t('请输入手机号码'),type:'warning'})
                return
            }
            this.$httpSys.post("smsAliyun/pass/aliyun/senderCodeMsgByForget",{phone:telPhone,areaCode:this.passwordForm.areaCode}).then(data=>{
                this.forgettime = 60;
                let inter = setInterval(()=>{
                    this.forgettime -- ;
                    if(this.forgettime==0){
                        clearInterval(inter)
                    }
                },1000)
                this.$message({message:this.$t('发送成功'),type:'success'})
            })
        },
        handlePassword() {
            this.$refs.passwordForm.validate(valid => {
                if (valid) {
                    this.$httpSys.put("auth/userOuter/pass/forgetPwd",this.passwordForm).then(data=>{
                        this.changeType('loginForm')
                        this.$message({message:this.$t('操作成功'),type:'success'})
                    })
                }
            })
        }
    }
}

export default passwordMixin